import { debugLog } from "./logger";

const API = process.env.REACT_APP_BACKEND_URL;

export const trackEvent = (eventType, path) => {
    try {
        fetch(`${API}/api/analytics/event`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ event_type: eventType, path }),
            keepalive: true,
        }).catch((error) => {
            debugLog("Analytics event not sent:", error);
        });
    } catch (error) {
        // analytics must never break the app
        debugLog("Analytics error:", error);
    }
};
